import SignIn from "features/auth/SignIn";
import AdminLayout from "layouts/admin";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "routes/PrivateRoute";

const App = () => {
  return (
    <Routes>
      <Route path="/auth" element={<SignIn />} />

      <Route element={<PrivateRoute />}>
        <Route path="admin/*" element={<AdminLayout />} />
        <Route path="/" element={<Navigate to="/auth" replace />} />
      </Route>
    </Routes>
  );
};

export default App;
